import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DashboardService } from '../components/dashboard/dashboard.service';

export const dashboardGuard: CanActivateFn = async (_route, _state) => {
    const router = inject(Router);
    const dashboardService = inject(DashboardService);
    const url = new URL(window.location.href);
    const projectId = url.searchParams.get('projectId');
    if (!projectId) {
        return false;
    }
    const dashboard = await dashboardService.getDashboardStatus(projectId);
    const isDashboardEnabled = dashboard.enabled;
    const params = url.searchParams?.toString() + '';
    if (isDashboardEnabled !== true) {
        return router.parseUrl(`/home/cases?${params}`);
    }

    return true;
};
